import { createSelector } from '@ngrx/store';
import { SELECT_MARKETPLACE_ITEM } from '@store/marketplace';

export const SELECT_IS_USER_EMAIL_VERIFICATION_PLUGIN_ACTIVE = createSelector(
  SELECT_MARKETPLACE_ITEM,
  marketplace =>
    marketplace?.plugins?.some(
      plugin => plugin.type === 'user-email-verification' && plugin.plugin_enabled,
    ) ?? false,
);
